var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseBlack = function SvgCloseBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m17.417 5.876-1.293-1.293L11 9.707 5.876 4.583 4.583 5.876 9.707 11l-5.124 5.124 1.293 1.293L11 12.292l5.124 5.125 1.293-1.293L12.292 11z"
  }))));
};
export { SvgCloseBlack as ReactComponent };
export default __webpack_public_path__ + "bd16239fee7d6a9221537b56ce6630d3.svg";